import { useContext } from "react"
import { AuthContext } from "../contexts/auth/AuthContext"
import i18n from "../services/i18n"

// tog'a #4100 / #4104 (2026-10-10): tovar PARTIYASI faqat glavniy tizimda (tenant 1, SAV) ko'rsatiladi —
// hamkor tizimlariga (tenant > 1) partiya raqami umuman kerak emas. Bu FAQAT ko'rinish: serverga ketadigan ma'lumot o'zgarmaydi.
// tenantId login javobida (AuthLogic, #556) ham, AccountAPI/MyPermissions da ham DOIM keladi (SAV = 1), shuning uchun
// tekshiruv qat'iy: tenantId yo'q bo'lsa glavniy deb HISOBLANMAYDI — partiya hamkorga tasodifan chiqib ketmasin.
// (Boshqa joylardagi `Number(tenantId || 1)` naqshi «yo'q = glavniy» deydi; bu yerda ataylab teskari — xato tomoni ko'rsatmaslik.)

/** Foydalanuvchi glavniy tizimdanmi (tenantId === 1). */
export function isMainUser(user: any): boolean {
  return Number(user?.tenantId) === 1
}

/** Joriy foydalanuvchi (localStorage) glavniy tizimdanmi — hook ishlatib bo'lmaydigan joylar uchun (render funksiyalari, oddiy funksiyalar). */
export function isMainSystem(): boolean {
  try {
    return isMainUser(JSON.parse(localStorage.getItem("user") || "{}"))
  } catch {
    return false
  }
}

/** Hook: AuthContext dan o'qiydi — kirish yoki huquqlar yangilangach komponent qayta chiziladi.
 *  Provayderdan tashqarida (masalan Modal.info/confirm ichidagi komponent) context bo'sh — localStorage dan o'qiladi. */
export function useIsMainSystem(): boolean {
  const ctx = useContext(AuthContext) as any
  return ctx?.authState ? isMainUser(ctx.authState.user) : isMainSystem()
}

// Mavjud partiya ustunini tanish: dataIndex (massiv bo'lsa oxirgi bo'lagi) yoki sarlavha (uchala tilda)
const BATCH_FIELDS = ["batchnumber", "batches", "salebatchnumber"]
let batchTitles: Set<string> | null = null
const batchTitleSet = (): Set<string> => {
  if (!batchTitles) {
    const s = new Set<string>(["Партия", "Номер партии"])
    ;["ru", "uz", "en"].forEach((lng) => {
      try {
        const tt = i18n.getFixedT(lng)
        s.add(String(tt("numberParty")))
        s.add(String(tt("batchLbl")))
      } catch {}
    })
    batchTitles = s
  }
  return batchTitles
}

/** Jadval ustuni partiya ustunimi (hamkor tizimida TableExtended uni olib tashlaydi). */
export function isBatchColumn(col: any): boolean {
  if (!col) return false
  const di = col.dataIndex
  const last = Array.isArray(di) ? di[di.length - 1] : di
  if (last != null && BATCH_FIELDS.includes(String(last).toLowerCase())) return true
  return typeof col.title === "string" && batchTitleSet().has(col.title)
}
